export const HELP_MESSAGE =
  "Here you will find our projected performance for every player. Projected fantasy points use each daily site's specific scoring settings. Value is determined by a points per dollar ratio (usually, per $1000 in salary).";

export default {};
